import React from 'react';
import logoWhite from '../images/logo-white.png';

export default function NavigationBar() {
    return (
        <header className="bd-nav">
            <a href="#home" className="bd-nav__brand">
                <div className="bd-nav__logo">
                    <img src={logoWhite} alt="Raj Printers & Associates Logo" />
                </div>
                <div className="bd-nav__title">Raj Printers & Associates</div>
            </a>
            <nav className="bd-nav__links">
                <a href="#work">Catalogue</a>
                <a href="#stamp-section">Order Stamps</a>
                <a href="#contact">Visit us</a>
                <a href="#about">About</a>
            </nav>
            <div className="bd-nav__cta">
                <a href="tel:+919982066620" className="bd-nav__phone">+91 99820 666 20</a>
                <a
                    href="https://wa.me/919413341382"
                    className="bd-btn bd-btn--dark"
                    target="_blank"
                    rel="noreferrer"
                >
                    Get a quote <span aria-hidden>→</span>
                </a>
            </div>
        </header>
    );
}
